import React from 'react';
import ReactDOM from 'react-dom';

import { MainRouter } from './componets/navigation/main';

import './assets/style/index.scss';

ReactDOM.render(<React.StrictMode><MainRouter /></React.StrictMode>,document.getElementById('root'));